/**
 * Role groups used for route/feature guards across apps.
 * Values are additive: `admin` includes Super Admin, `user` includes Admin + Super Admin.
 */
export const authRoles = {
  superAdmin: ["Super Admin"] as string[],
  admin: ["Admin", "Super Admin"] as string[],
  user: ["User", "Admin", "Super Admin"] as string[],
};

/** Returns true when the user holds at least one Super Admin role. */
export function isSuperAdmin(
  user: { role: string | string[] } | null,
): boolean {
  if (!user) return false;
  const roles = Array.isArray(user.role) ? user.role : [user.role];
  return roles.some((r) => authRoles.superAdmin.includes(r));
}
